"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.tiles)
    }, [
        (_ctx.symbols.length > 0)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 0,
                class: (0, vue_1.normalizeClass)(_ctx.symbols)
            }, null, 2))
            : (0, vue_1.createCommentVNode)("", true)
    ], 2));
}
